export default {
  hint: {
    1: 'Save platform',
    2: 'Satisfied or refunded within 14 days',
    3: 'Follow-up and advice',
    4: 'Developed by professionals',
  }
}
